<template>
  <div class="choose-course">
    <ul>
      <li
        v-for="(item, index) in data"
        :key="index"
        class="chapter-list pointer"
      >
        <div class="chapter-list-header">
          <div
            v-if="showTag"
            class="chapter-plus"
            :class="item.active ? 'is-active' : ''"
            @click.self="onItemClick(item)"
          />
          <div
            :class="item.active && !showTag ? 'is-active' : ''"
            class="chapter-list-content"
            @click.self="onItemClick(item)"
          >
            {{ item.lesson_name }}
          </div>
        </div>
        <ul class="lesson-list" v-show="item.active && showTag">
          <li
            v-for="(lesson, lessonIndex) in item.packInfo"
            :key="lessonIndex"
            class="lesson-item pointer"
          >
            <div
              class="lesson-item-content"
              @click.stop="
                choiceSingle(index, lessonIndex, lesson['active'], lesson)
              "
              :class="[lesson.active ? 'is-checked' : '']"
            >
              <div
                class="circle-check-item"
                :class="[lesson.active ? 'is-checked' : '']"
              >
                <div class="circle-check-box" />
              </div>
              <p>
                {{ lesson.tag_name }}
              </p>
            </div>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { getQuestionPackageList } from '@/api/pt';
// import { number } from 'echarts';

export default {
  name: 'ChooseKnowledgePoints',
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    multi: {
      default: false,
      type: Boolean,
    },
    showTag: {
      default: true,
      type: Boolean,
    },
    fromType: {
      default: '',
      type: [Number, String],
    },
    type: {},
  },
  data() {
    return {
      knowledgeList: [],
      choiceKnowledgeList: [],
      list: [],
    };
  },
  computed: {
    ...mapGetters(['categoryObj', 'atKnowledgeList', 'questionsBasket', 'commonWeakCategoryObj', 'commonWrongCategoryObj']),
    category() {
      if (this.type === 'CommonWeak') {
        return this.commonWeakCategoryObj;
      } if (this.type === 'CommonWrong') {
        return this.commonWrongCategoryObj;
      }
      return this.categoryObj;
    },
  },
  methods: {
    onItemClick(item) {
      this.$set(item, 'active', !item.active);
      if (!this.showTag) {
        // 不展开的时候,只能同时有一个 active
        this.data.forEach((c) => {
          // eslint-disable-next-line no-param-reassign
          c.active = false;
        });
        // eslint-disable-next-line no-param-reassign
        item.active = true;
        this.data.forEach((course) => {
          if (course.lesson_id !== item.lesson_id) {
            this.$set(course, 'active', false);
          }
        });
        this.$emit('changeCourse', item);
      } else {
        const courseInfo = {
          courseId: item.course_id,
          courseName: item.course_name,
          lessonId: item.lesson_id,
        };
        this.$store.commit('CHANGE_COURSE_INFORMATION', courseInfo);
        if (!item.packInfo && item.active) {
          this.getQuestionPackageList(item);
        }
      }
    },
    // 获取知识点列表
    getQuestionPackageList(item) {
      this.knowledgeList = [];
      const params = {
        subject_id: this.category.subjectId,
        hw_type: this.fromType,
        module_id: item.lesson_id,
        // module_id: 1193266316578363,
      };
      getQuestionPackageList(params).then((res) => {
        if (res.code === 200) {
          const knowledgeArr = res.data;
          if (knowledgeArr.length > 0) {
            knowledgeArr.forEach((knowledge) => {
              this.knowledgeList.push({
                tag_code: knowledge.tag_code,
                tag_name: knowledge.tag_name,
                active: false,
                type: '理科',
              });
            });
            this.$set(item, 'packInfo', this.knowledgeList);
            // this.$set(item, 'packInfo', this.list);
          }
        }
      });
    },
    // 选择一个知识点
    choiceSingle(index, lessonIndex, isChecked, lesson) {
      // MT仅作知识点切换
      if (Number(this.fromType) === 3) {
        this.data.forEach((dataItem) => {
          if (dataItem.packInfo && dataItem.packInfo.length > 0) {
            dataItem.packInfo.forEach((packItem) => {
              this.$set(packItem, 'active', false);
              if (packItem.tag_code === lesson.tag_code) {
                this.$set(packItem, 'active', true);
                this.$emit('toggle', packItem);
              }
            });
          }
        });
      }
      // AMT最多选择10个知识点
      if (Number(this.fromType) === 4 || this.multi) {
        if (this.atKnowledgeList.length === 10 && !isChecked) {
          this.$message({
            message: '最多选择10个知识点',
            type: 'worry',
          });
          return;
        }
        this.$set(this.data[index].packInfo[lessonIndex], 'active', !isChecked);
        this.getChildCount();
      }
    },
    // 选中了多少个知识点
    getChildCount() {
      this.choiceKnowledgeList = [];
      this.data.forEach((courseItem) => {
        if (courseItem.packInfo && courseItem.packInfo.length > 0) {
          courseItem.packInfo.forEach((lessonItem) => {
            if (lessonItem.active) {
              this.choiceKnowledgeList.push(lessonItem);
            }
          });
          this.$store.commit('CHOOSE_KNOWLEDGE', this.choiceKnowledgeList);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.choose-course {
  padding-bottom: 10px;
  .chapter-list {
    display: flex;
    // align-items: baseline;
    // justify-content: flex-start;
    margin-top: 10px;
    flex-wrap: wrap;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: bolder;
    color: #000000;
    .chapter-plus {
      height: 12px;
      width: 18px;
      color: rgba(0, 0, 0, 1);
      font-size: 16px;
      background-repeat: no-repeat;
      background-size: 12px 12px;
      background-image: url("~@/views/pt/images/plus.png");
      &.is-active {
        background-image: url("~@/views/pt/images/minus.png");
      }
    }
    .chapter-list-header {
      display: flex;
      align-items: baseline;
      justify-content: flex-start;
    }
    .lesson-list {
      width: 100%;
      .circle-check-item {
        height: 100%;
        display: flex;
        align-items: center;
        .circle-check-box {
          position: relative;
          width: 12px;
          height: 12px;
          margin-right: 12px;
          border: 1px solid rgba(17, 31, 44, 0.4);
          display: inline-block;
          box-sizing: border-box;
          &:after {
            position: absolute;
            width: 3px;
            height: 6px;
            left: 2.5px;
            box-sizing: content-box;
            content: "";
            border: 2px solid #ffffff;
            border-left: 0;
            border-top: 0;
            transform: rotate(45deg) scaleY(0);
            transition: transform 0.15s ease-in 0.05s;
            transform-origin: center;
          }
        }
        &.is-checked {
          .circle-check-box {
            background-color: #409eff;
            border-color: #409eff;
            &:after {
              transform: rotate(45deg) scaleY(1);
            }
          }
        }
      }
      .lesson-item {
        padding-left: 44px;
        margin-top: 16px;
        font-weight: 400;
        color: rgba(96, 98, 102, 1);
        font-size: 15px;
        margin: 13px 0;
        position: relative;
        background: url("~@/views/pt/images/minus_2.png") no-repeat 20px 3px;
        background-size: 12px 12px;
        &::before {
          content: "";
          height: 100%;
          width: 1px;
          border-left: 1px dashed rgba(196, 200, 210, 1);
          left: 26px;
          top: 18px;
          position: absolute;
        }
        &:last-of-type::before {
          display: none;
        }
        .lesson-item-content {
          display: flex;
          align-items: baseline;
          justify-content: flex-start;
          padding-right: 5px;
          &.is-checked {
            color: rgba(25, 137, 250, 1);
          }
        }
      }
    }
  }
  .chapter-list-content.is-active {
    color: #1989fa;
  }
}
</style>
